import * as z from 'zod';

export const VentilationSchema = z.object({
  system: z.string().optional(),
  isVariableAirVolumeSystem: z.boolean().optional(),
  hasCO2Sensors: z.boolean().optional(),
  hasParkadeCOSensors: z.boolean().optional(),
});

export type Ventilation = z.infer<typeof VentilationSchema>;
